export const ICON_BUTTONS = `
  <button type="button" class="datepicker-button-toggle"  data-mdb-toggle="datepicker">
    <i class="far fa-calendar datepicker-toggle-icon"></i>
  </button>
  <button type="button" class="timepicker-button-toggle" data-mdb-toggle="timepicker">
    <i class="far fa-clock fa-sm timepicker-icon"></i>
  </button>
`;

export const TOGGLE_BUTTON = `
  <button type="button" class="datetimepicker-toggle-button" data-mdb-toggle="datetimepicker">
    <i class="far fa-calendar datepicker-toggle-icon"></i>
  </button>
`;
